import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../lib/translations";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: translations.en,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("lang") || "en";
    }
    return "en";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    if (typeof window !== "undefined") {
      localStorage.setItem("lang", next);
    }
  }, []);

  const value = {
    lang,
    setLang,
    t: translations[lang] || translations.en,
  };

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
